import { FetchAPI } from "../Main/fetchAPI";
import { CLIENTS } from "../constants";

export const DiagnosisCode = {
    getDiagnosisCode: () => FetchAPI.getJson({
        urlStr: `${CLIENTS}/diagnosis-codes`,
    }),
}
